/* eslint-disable no-param-reassign */
import React, { createContext } from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/shared/SEO'
import LcpPreload from 'components/shared/LcpPreload'
import Layout from 'components/layout/Layout'
import FlexContentHandler from 'components/shared/FlexContentHandler'

export const ProjectContext = createContext({
  title: '',
  categories: [],
  location: '',
})

interface PageTemplateProps {
  data: {
    page: {
      path?: string
      title: string
      projectcategories?: any
      recap?: any
      seo: any
      flexContent: any
    }
  }
  location?: any
  prefix?: string
}

const PageTemplate: React.FC<PageTemplateProps> = ({
  data: {
    page: { title, projectcategories, recap, flexContent, seo },
  },
  location = {},
  prefix = 'Project_Flexcontent',
}) => {
  if (seo) {
    seo.schema = [
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: location.origin,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: seo.title,
            item: location.href,
          },
        ],
      },
    ]
  }
  return (
    <Layout>
      <SEO seo={seo} />
      <LcpPreload flexContent={flexContent} />
      <ProjectContext.Provider
        value={{
          title,
          categories: projectcategories?.nodes,
          location: recap?.location.name,
        }}
      >
        <FlexContentHandler
          prefix={prefix}
          fields={flexContent}
          location={location}
        />
      </ProjectContext.Provider>
    </Layout>
  )
}

export const pageQuery = graphql`
  query projectById($pageId: String!) {
    page: wpProject(id: { eq: $pageId }) {
      ...generalProjectFragment
    }
  }
`

export default PageTemplate
